import type {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-z0-9._-]+\.[a-z]{2,4}$/;

export const onyxEmailValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  if (!control.value) return null;

  const value = String(control.value.trim());
  return EMAIL_PATTERN.test(value) ? null : { email: true };
};
